<div class="item-inner">
  <div class="item-header text-4 col-12">
    {{ qualificationCall.business ? qualificationCall.business : ('general.na' | translate) }}
  </div>
  <div class="item-sub-header text-5 col-12">
    {{ qualificationCall.companyName }}
  </div>
  <div class="item-content col-12">
    <div class="amount text-bold-2">{{ qualificationCall.totalPrice | currency }}</div>
    <div class="products text-5">
      @for (product of qualificationCall.products; track product) {
        <div class="product">{{ product.productVariant?.name }}<div class="price">{{ product.totalPrice | currency }}</div></div>
      }
    </div>
  </div>
  <div class="item-footer col-12 text-bold-2">
    <div class="date text-4">{{ qualificationCall.signDate | customDate: 'shortDate' }}</div>
    <div>{{ getTeamShortName(qualificationCall.salesTeamId) }}@if (qualificationCall.seller) {
      <span>{{ qualificationCall.sellerId | user: 'initials' }}</span>
    }</div>
  </div>
</div>
